module.exports = __webpack_public_path__ + "static/media/ardc-logo.8d6b5421.svg";